// ブラウザで動かす部品 (島) の一覧。書き出し (island.tsx) とブラウザ (client.tsx) の両方が読む。
// 名前は src/ からの道 + '#' + 部品の名前 (vite の useClientIslands が付ける名前と同じ)。
// LP のページに 'use client' の部品を足したら、ここと client.tsx の LOADERS に足す (足さないと書き出しが止まる)。
import type { ComponentType, ReactNode } from 'react';
import { ToastProvider } from '@/components/ui/toast';

export const ISLAND_IDS = [
  'app/(marketing)/_components/site-header#SiteHeader',
  'app/(marketing)/_components/floating-cta#FloatingCta',
  'app/(marketing)/_components/template-promo#TemplatePromo',
  'components/analytics/doc-request-link#DocRequestLink',
  'app/(marketing)/contact/contact-form#ContactForm',
  'app/(marketing)/blog/_components/blog-filter#BlogFilter',
  'app/(marketing)/templates/_components/templates-filter#TemplatesFilter',
  // 今の root layout の、どのページにもある部品 (GA・トースト・登録の計測)。apps/lp/src/app-shell.tsx
  'lp/app-shell#AppShell',
] as const;

export type IslandId = (typeof ISLAND_IDS)[number];

/** 島の外側に置く部品 (今の root layout の ToastProvider の中にあったもの) */
export function islandWrap(id: IslandId): ComponentType<{ children: ReactNode }> | null {
  if (id === 'app/(marketing)/contact/contact-form#ContactForm' || id === 'lp/app-shell#AppShell')
    return ToastProvider;
  return null;
}
